import "./backdrop.css.js";
const o = {
  backdrop: "pf-v6-c-backdrop",
  backdropOpen: "pf-v6-c-backdrop__open"
};
export {
  o as default
};
